import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import { trackEvent } from "../../appInsights/TelemetryService";
import * as api from "../../api";
import { isNullOrUndefined, formatDateWithFromCalendar } from "../../utils/formatting";
import { useDispatch, useSelector } from "react-redux";
import { AssetTypes } from "../../models/shared/Enum";
import keyContactsImg from '../../assets/icons/keyContacts.png';
import '../../utils/commonCss/icons.css'
import { BalanceType } from "../../models/Accounts/BalanceType";
import { PermissionsList } from "../../models/Permissions";
import { assetData } from "../../ducks/redux/actions/getAddress";
import ErrorComponent from "../APIErrorComponent/ErrorComponent";
import { getKeyContact, getAssociatedAssets, getCustomer, getTenancies, getAccountByIdServiceCharges, getAssetsById } from "../APIErrorComponent/APIConstantName";
import { storeAPIErrors } from "../../ducks/redux/actions/FinancialReferral";
import { addAPIError, removeAPIError } from "../../utils/translation/helper";
import { Helper } from "../../utils/Helper/HelperUtil";


interface KeyContactProps extends RouteComponentProps<any> {
    selectedProperty: string;
}

const titleCase = (str: string): string => {
    return str?.replaceAll(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
    );
};

const renderManagerDetails = (t: any, regionalHousingManager: string, neighManager: string, lettingsOfficer: string, areaHousingManagerName: string, incomesOfficer: string, assistantHeadOfNeighbourhoodsName: string) => {
    return (
        <div className="px-4 grid grid-cols-1 md:grid-cols-2">
           <div>  
            {/* <div className="px-2 py-2"> */}
              <div className="px-2 py-2">
                <div><b>{t("neighbourhood")}</b></div>
                <div className="text-capitalize">{titleCase(neighManager) || '-'}</div>
              </div>
              <div className="px-2 py-2">
                <div><b>{t("assistantHeadOfNeighbourhoods")}</b></div>
                <div className="text-capitalize">{titleCase(assistantHeadOfNeighbourhoodsName) || '-'}</div>
              </div>
               <div className="px-2 py-2">
                <div><b>{t("areaHousingManager")}</b></div>
                <div className="text-capitalize">{titleCase(areaHousingManagerName) || '-'}</div>
               </div>
                <div className="px-2 py-2">
            
                <div><b>{t("regionalHousingManager")}</b></div>
                <div className="text-capitalize">{titleCase(regionalHousingManager)||'-'}</div>
            </div>
           
            </div>
<div>
           
            <div className="px-2 py-2">
                <div className="pr-4"><b>{t("lettings")}</b></div>
                <div className="text-capitalize">{titleCase(lettingsOfficer) || '-'}</div>
            </div>
            
            <div className="px-2 py-2">
                <div className="pr-4"><b>{t("incomes")}</b></div>
                <div className="text-capitalize">{titleCase(incomesOfficer) ||'-'}</div>
            </div>
            </div>
        </div>
    );
};


const formatFullName = (givenName = "", surname = ""): string => {
    const fullName = `${givenName} ${surname}`.trim();
    return fullName && fullName !== " " ? titleCase(fullName) : "-";
};


const getKeyContactId = async (
    backValue: string,
    caseData: any,
    assetDetails: any,
    errors: any,
    dispatch: any
): Promise<string | null> => {
    let errorData = [];
    
    if (backValue !== "Case360View") {
        return assetDetails?.id;
    }

    
    const isNMOrIncomes = caseData.assignee === "NM" || caseData.assignee === "Incomes officer";
    
    if (isNMOrIncomes && !isNullOrUndefined(caseData.identifiers.customerIdentifier) && !isNullOrUndefined(caseData.identifiers.tenancyIdentifier)) {
        try {
            const customerResponse = await api.getCustomer(caseData.identifiers.customerIdentifier);
            errorData = removeAPIError(getCustomer, errors);
            dispatch(storeAPIErrors(errorData));
            
            let keyContactId: string | null = null;
            customerResponse.tenanciesSummaries.find((assetid: any) => {
                if (assetid.tenancySummary.tenancyId === caseData.identifiers.tenancyIdentifier) {
                    keyContactId = assetid.tenancySummary.premisesIds[0];
                    return true;
                }
                return false;
            });
            return keyContactId;
        } catch (error) {
            console.error("Error fetching customer", error);
            errorData = addAPIError(getCustomer, errors);
            dispatch(storeAPIErrors(errorData));
            return null;
        }
    }

    if (isNMOrIncomes && caseData.asset.type.assetTypeName !== "Property" || caseData.assigneeType === "Team") {
        const associatedAssetsResponse = await api.getAssociatedAssetsKey(caseData.identifiers.assetIdentifier);
        const associatedAsset = associatedAssetsResponse.find((x: any) => x.assetType === AssetTypes.Property);
        return associatedAsset?.id ?? null;
    }

    return assetDetails?.id;
};

const KeyContact: React.FC<KeyContactProps> = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    let errorData: any = [];
    const [lettingsOfficer, setLettingsOfficer] = useState("");
    const [incomesOfficer, setIncomesOfficer] = useState("");
    const [neighManager, setNeighManager] = useState("");
    const [regionalHousingManager, setRegionalHousingManager] = useState("");
    const [previousLandlordName, setPreviousLandlordName] = useState("");
    const [areaHousingManagerName, setAreaHousingManagerName] = useState("");
    const [assistantHeadOfNeighbourhoodsName, setAssistantHeadOfNeighbourhoodsName] = useState("");
    const tenancyTypeDescription = useSelector((state: any) => state?.userChoicesReducer?.userChosenTenancyTypeDescription);
    const [liveBalancedNumber, setLiveBalancedNumber] = useState(0.0);
    const [liveBalanceType, setLiveBalanceType] = useState("");
    const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);
    const assetDetails = useSelector(
        (state: any) =>
            state?.dashboardReducer?.formState?.assetByIdDataObject
    );
    const backValue = useSelector(
        (state: any) => state?.userChoicesReducer?.backValue
    );
    const caseData = useSelector(
        (state: any) => state?.userChoicesReducer?.caseData
    );
    const customerTenancy = useSelector(
        (state: any) => state?.addresses?.saveCustomerDetails?.tenanciesSummaries
    );
   
    const accountData = (useSelector(
        (state: any) => state.userChoicesReducer?.accountData)
    );

    const getPermissionsData = useSelector(
        (state: any) => state?.userChoicesReducer?.userProfilePermissions
    );
 
    const [selectedPremise, selectedTenancy, selectedPaymentReference] = props.selectedProperty?.split("_") || [];        

    const colleagueCompanyName = localStorage.getItem('user_companyName') || ""
    let hideCustomerKeyDetails = colleagueCompanyName?.toLowerCase() === "orbis"
    useEffect(() => {
        if(props.selectedProperty && assetDetails)
        {
        trackEvent("KeyContact");
        getKeyContactData();
        }
    }, [props.selectedProperty, assetDetails]);
    
  const callProperty360 = () => {
    dispatch(assetData(assetDetails));
    props.history.push("/Asset360View");
  };

  const fetchGetPropertyAssociates = async (keyContactId: string) => {
    try {
      const contactData = await api.getKeyContact(keyContactId);
      errorData = removeAPIError(getKeyContact, errors);
      dispatch(storeAPIErrors(errorData));
      return contactData;
    } catch (e) {
      errorData = addAPIError(getKeyContact, errors);
      dispatch(storeAPIErrors(errorData));
      return null;
    }
  };

  const setManagerDetailsFromContact = (contactData: any) => {
    if (!contactData?.associates) return;

    setRegionalHousingManager(
      formatFullName(
        contactData.associates.regionalHousingManager?.person?.name?.givenName,
        contactData.associates.regionalHousingManager?.person?.name?.surname
      )
    );
    setIncomesOfficer(
      formatFullName(
        contactData.associates.incomesOfficer?.person?.name?.givenName,
        contactData.associates.incomesOfficer?.person?.name?.surname
      )
    );
    setLettingsOfficer(
      formatFullName(
        contactData.associates.lettingsOfficer?.person?.name?.givenName,
        contactData.associates.lettingsOfficer?.person?.name?.surname
      )
    );
    setNeighManager(
      formatFullName(
        contactData.associates.neighbourhoodManager?.person?.name?.givenName,
        contactData.associates.neighbourhoodManager?.person?.name?.surname
      )
    );
    setPreviousLandlordName(contactData.associates.previousLandLord?.organisation?.name || "-");
    setAreaHousingManagerName(
      formatFullName(
        contactData.associates.areaHousingManager?.person?.name?.givenName,
        contactData.associates.areaHousingManager?.person?.name?.surname
      )
    );
    setAssistantHeadOfNeighbourhoodsName(
      formatFullName(
        contactData.associates.assistantHeadOfNeighbourhoods?.person?.name?.givenName,
        contactData.associates.assistantHeadOfNeighbourhoods?.person?.name?.surname
      )
    );
  };

  const getKeyContactData = () => {
    (async () => {
      try {
        if (isNullOrUndefined(assetDetails?.id)) return;

        const keyContactId = await getKeyContactId(backValue, caseData, assetDetails, errors, dispatch);
        if (!keyContactId) return;

        const contactData = await fetchGetPropertyAssociates(keyContactId);
        if (contactData) {
          setManagerDetailsFromContact(contactData);
        }
      } catch (e) {
        console.error(e);
        dispatch(storeAPIErrors(addAPIError(getKeyContact, errors)));
      }
    })();
  };


    useEffect(() => {
        if (isNullOrUndefined(accountData?.["balance"])) {
            return;
        }

        accountData?.["balance"].forEach((balance: any) => {
            if (balance["balance-type"] === BalanceType?.Livebalanced) {
                const liveBalanced = balance["monetary-amount"]["value"];
                const accountBalanceValue = Number.parseInt(liveBalanced);

                if (Number.isNaN(accountBalanceValue)) {
                    setLiveBalanceType("");
                    setLiveBalancedNumber(0);
                    return;
                }

                setLiveBalanceType(accountBalanceValue > 0 ? "In arrears" : "In credit");
                setLiveBalancedNumber(Math.abs(Number.parseFloat(liveBalanced.toString().replaceAll(',', ""))));
            }
        });
    }, [accountData]);
    let uprn;
    let paymentReference;
    let paymentMethod;
    let tenancyStartDate;
    let tenancyIdentifier;

    if (assetDetails?.assetStatus === Helper.AssetStatuses.Occupied) {
        const tenancySummary = customerTenancy.find((tenancy: any) =>
        tenancy.tenancySummary?.tenancyId === selectedTenancy &&
        tenancy.tenancySummary?.premisesIds?.includes(selectedPremise) &&
        tenancy.tenancySummary?.paymentReference === selectedPaymentReference
    )?.tenancySummary;
        uprn = isNullOrUndefined(tenancySummary?.uprn) ? "-" : tenancySummary?.uprn;
        paymentReference = isNullOrUndefined(tenancySummary?.paymentReference) ? "-" : tenancySummary?.paymentReference;
        paymentMethod = isNullOrUndefined(tenancySummary?.paymentMethod) ? "-" : tenancySummary?.paymentMethod;
        tenancyStartDate = isNullOrUndefined(tenancySummary?.tenancyStartDate) ? "-" : tenancySummary?.tenancyStartDate;
        tenancyIdentifier =
            isNullOrUndefined(accountData?.identifiers) || isNullOrUndefined(accountData?.identifiers["tenancy-identifier"])
                ? "-"
                : accountData?.identifiers["tenancy-identifier"];
    } else {
        hideCustomerKeyDetails = true;
    }

    const showKeyCardDetails = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_customer360_keydetails_card);
    if (showKeyCardDetails !== -1 && !hideCustomerKeyDetails && backValue === "Customer360View" && window.screen.width > 820) {
        return (
            <>
                <div className="relative pb-16 border border-grey bg-grey rounded-lg cust-card global-txt">
                    <div className="py-2 px-4 border-b border-grey bg-teal rounded-t-lg">
                        <div className=" flex flex-row d-flex bd-highlight items-center">
                            <img src={keyContactsImg} alt="" className=" text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" />
                            <h2 className="my-0 text-white bd-highlight">{t("Key_contacts")}</h2>
                        </div>
                    </div>
                    <div className="px-4 grid grid-cols-1 md:grid-cols-2">
                        <div className="px-2 py-2">
                            <div className="pr-4"> 
                        <strong>{t("UPRN")}</strong></div>
                            {uprn?  < button type={undefined} className="global-txt text-teal underline-new-bg-grey cursor-pointer dropdown-menu-button"                                
                            onClick={() => callProperty360()}
                            onKeyPress={() => callProperty360()}>
                                <div className="text-capitalize">{uprn}</div>
                            </button>:"-"}
                        </div>
                        <div className="px-2 py-2">
                            <div className="pr-4"><b>{t("tenancy_type")}</b></div>
                    <div className="text-capitalize">{isNullOrUndefined(tenancyTypeDescription) ? '-' : tenancyTypeDescription}</div>
                        </div>
                        <div className="px-2 py-2">
                            <div className="pr-4"><b>{t("pay_ref")}</b></div>
                            <div className="text-capitalize">{titleCase(paymentReference)||'-'}</div>
                        </div>
                        <div className="px-2 py-2">
                            <div className="pr-4"><b>{t("Tenancy_ref")}</b></div>
                            <div className="text-capitalize ">{titleCase(tenancyIdentifier)||'-'}</div>
                        </div>
                        <div className="px-2 py-2">
                            <div className="pr-4"><b>{t("Payment_method")}</b></div>
                            <div className="text-capitalize">{titleCase(paymentMethod)||'-'}</div>
                        </div>
                        <div className="px-2 py-2">
                            <div className="pr-4"><b>{t("TenancyStartDate")}</b></div>
                            <div className="text-capitalize">{(formatDateWithFromCalendar(tenancyStartDate))||'-'}</div>
                        </div>
                        <div className="px-2 py-2">
                            <div className="pr-4"><b>{t("Live_Balance")}</b></div>
                            <div className="text-capitalize">{("£" + liveBalancedNumber + " " + liveBalanceType) || '-'}</div>
                        </div>
                        <div className="px-2 py-2">
                            <div className="pr-4"><b>{t("Former_Landlord")}</b></div>
                            <div className="text-capitalize">{titleCase(previousLandlordName)||'-'}</div>
                        </div>
                    </div>
                    <hr />
                    {renderManagerDetails(t, regionalHousingManager, neighManager, lettingsOfficer, areaHousingManagerName, incomesOfficer, assistantHeadOfNeighbourhoodsName)}
                    <ErrorComponent input={[getCustomer, getKeyContact, getAssociatedAssets, getTenancies, getAccountByIdServiceCharges]}/>
                </div>
            </>
        )
    }
    else {
        return (

            <div className="relative pb-16 border border-grey bg-grey rounded-lg cust-card global-txt">
                <div className="py-2 px-4 border-b border-grey bg-teal rounded-t-lg">
                    <div className=" flex flex-row d-flex bd-highlight items-center">
                        <img src={keyContactsImg} alt="" className=" text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" />
                        <h2 className="my-0 text-white bd-highlight">{t("Key_contacts")}</h2>
                    </div>
                    
                </div>
                {renderManagerDetails(t, regionalHousingManager, neighManager, lettingsOfficer, areaHousingManagerName, incomesOfficer, assistantHeadOfNeighbourhoodsName)}
                <ErrorComponent input={[getCustomer, getKeyContact, getAssociatedAssets, getAssetsById]}/>
            </div>
           
        )
    }
};

export default KeyContact;